













import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import ShoppingCartContinueShopping from '@accounting/components/shopping-cart/shopping-cart-continue-shopping.vue';
import PaymentCheckoutStatus from '@accounting/components/payment-checkout-status.vue';

@Component({
  name: 'bpc-invoice-payment-confirmation-page',
  components: {
    'bpc-page-title': BpcPageTitle,
    'bpc-shopping-cart-continue-shopping': ShoppingCartContinueShopping,
    'bpc-payment-checkout-status': PaymentCheckoutStatus,
  },
})
export default class InvoicePaymentConfirmationPage extends Vue {
  @Prop(String) readonly token: string;
  mounted() {
    console.log(this.$route.query['session_id']);
  }
}
